<div class="obj-manager-details">
  <div class="obj-manager-details__header">
    <div class="obj-manager-details__header__title">
      <span class="obj-manager-details__header__title__path"
        ><a [routerLink]="['../']">OBJECTS MANAGER</a> <span class="separator">/</span>EDIT</span
      >
      <h1 data-cy="custom-object-details-header" class="obj-manager-details__header__title__text">
        {{ customObject?.label }}
      </h1>
      @if (customObject?.api_handle) {
        <small> <strong>API Handle</strong>: {{ customObject?.api_handle }} </small>
      }
    </div>
    <div class="obj-manager-details__header__actions">
      <button
        mat-flat-button
        data-cy="manage-custom-fields"
        [tabIndex]="-1"
        (click)="navigateToCustomFields()"
        [disabled]="!customObject?.name"
      >
        <mat-icon class="mr-1" [svgIcon]="'link'"></mat-icon>
        Manage Custom Fields
      </button>
      <button
        *ngIf="selectedTabLabel === 'Relationships'"
        class="ml-2"
        mat-flat-button
        [color]="'primary'"
        [tabIndex]="-1"
        DebounceClick
        (debounceLoading)="isDebounceLoading($event)"
        (debounceClick)="addRelationshipToObject()"
      >
        <mat-icon class="mr-1" [svgIcon]="'add'"></mat-icon>
        New Relationship
      </button>
      <button
        *ngIf="selectedTabLabel !== 'Relationships'"
        class="ml-2"
        mat-flat-button
        [color]="'primary'"
        [tabIndex]="-1"
        DebounceClick
        (debounceLoading)="isDebounceLoading($event)"
        (debounceClick)="save()"
      >
        <mat-icon class="mr-1" [svgIcon]="'save'"></mat-icon>
        <span *ngIf="!isLoading">Save</span>
        <mat-progress-spinner *ngIf="isLoading" [diameter]="24" [mode]="'indeterminate'"></mat-progress-spinner>
      </button>

      @if (customObject?.id) {
        <button class="more-menu" mat-icon-button [matMenuTriggerFor]="moreMenu">
          <mat-icon [svgIcon]="'more_vert'"></mat-icon>
        </button>
      }

      <mat-menu #moreMenu="matMenu">
        <button mat-menu-item (click)="editCustomObject()">
          <mat-icon [svgIcon]="'edit'"></mat-icon>
          <span>Edit</span>
        </button>
        <button mat-menu-item (click)="deleteCustomObject()">
          <mat-icon [svgIcon]="'delete'"></mat-icon>
          <span>Delete</span>
        </button>
      </mat-menu>
    </div>
  </div>

  <div class="obj-manager-details__content">
    <mat-tab-group animationDuration="0ms" mat-align-tabs="start" (selectedTabChange)="selectedTabChange($event)">
      <mat-tab label="Relationships">
        <ng-container *ngIf="customObjects$ | async as customObjects">
          <table mat-table [dataSource]="linksDataSource">
            <!-- Object Name Column -->
            <ng-container matColumnDef="linked_type">
              <th mat-header-cell *matHeaderCellDef>Object Name</th>
              <td mat-cell *matCellDef="let link">{{ getLabelForLinked(link, customObjects) }}</td>
            </ng-container>

            <!-- Relationship Type Column -->
            <ng-container matColumnDef="relationship_type">
              <th mat-header-cell *matHeaderCellDef>Relationship Type</th>
              <td mat-cell *matCellDef="let link">
                @switch (link.relationship_type) {
                  @case ('one_to_many') {
                    One to many
                  }
                  @case ('many_to_one') {
                    Many to one
                  }
                  @case ('many_to_many') {
                    Many to many
                  }
                }
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="linksDisplayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: linksDisplayedColumns"></tr>
          </table>
        </ng-container>
      </mat-tab>
      @if (customObject?.id) {
        <mat-tab>
          <ng-template mat-tab-label>
            Configuration
            <mat-icon
              *ngIf="!customObject?.search_custom_field_id"
              class="ml-3 warning-icon"
              [svgIcon]="'warning'"
              matTooltip="Search field configuration is pending"
            ></mat-icon>
          </ng-template>

          <form class="obj-manager-details__content__config-form" [formGroup]="configurationsForm">
            <mat-form-field>
              <mat-label>Search Custom Field</mat-label>
              <mat-select formControlName="search_custom_field_id">
                <mat-option *ngFor="let option of searchCustomFieldOptions" [value]="option.id">
                  {{ option.label }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </form>
        </mat-tab>
      }
    </mat-tab-group>
  </div>
</div>
